module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-timetal__container"
  }, [_c('h4', {
    staticClass: "uppercase marg-1-bottom"
  }, [_vm._v("Personale")]), _vm._v(" "), (_vm.personaleUdenKorrekteOplysninger.length > 0) ? _c('div', {
    staticClass: "d-attention"
  }, [_c('svg', {
    staticClass: "tw-icon icon-important",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "primary",
    attrs: {
      "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
    }
  }), _c('path', {
    staticClass: "secondary",
    attrs: {
      "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Følgende personer mangler enten CPR-nummer eller Stilling.")]), _vm._v(" "), _c('p', [_vm._v("Gå til step 1. Undervisningskompetencer for at tilføje. Sæt til \"Ikke indberet\", hvis personen ikke skal indberettes.")]), _vm._v(" "), _c('table', {
    staticClass: "d-table d-table__borders"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.personaleUdenKorrekteOplysninger), function(user, key) {
    return _c('tr', {
      key: user.user_id
    }, [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.cpr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.stilling))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "d-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.groupedLaerereProps), function(group, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), _vm._l((group), function(prop) {
      return _c('td', [_vm._v("\n        " + _vm._s(prop.length) + "\n      ")])
    })], 2)
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th'), _vm._v(" "), _c('th', [_vm._v("CPR")]), _vm._v(" "), _c('th', [_vm._v("STILLING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Stilling")]), _vm._v(" "), _c('th', [_vm._v("Antal ansatte indberretes")]), _vm._v(" "), _c('th', [_vm._v("Heraf ansatte, der ikke er\n      registeret undervisningskompetencer for\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d20fdc52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/KompetenceIndberetning/Resume/IndberetPersonale.vue
// module id = 2129
// module chunks = 1